import { render } from "./Table.vue?vue&type=template&id=68507f46&scoped=true"
import script from "./Table.vue?vue&type=script&lang=js"
export * from "./Table.vue?vue&type=script&lang=js"

import "./Table.vue?vue&type=style&index=0&id=68507f46&scoped=true&lang=css"

import exportComponent from "C:\\Users\\User\\OneDrive\\工作案件\\前端管理介面\\vue3-adminlte3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68507f46"]])

export default __exports__